import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center p-8 bg-card border border-border rounded-lg">
        <h1 className="text-4xl font-bold mb-2">404</h1>
        <p className="text-lg text-muted-foreground mb-6">We couldn't find the page you're looking for.</p>
        <div className="space-x-3">
          <Link to="/" className="inline-block px-4 py-2 bg-primary text-white rounded">Go home</Link>
          <Link to="/contact" className="inline-block px-4 py-2 border border-border rounded">Contact support</Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
